import { Children } from 'react';

import './Button.dark.scss';
import './Button.light.scss';

interface Props {
  className?: string;
  style: 'raised' | 'stroked' | 'basic';
  color: 'primary' | 'accent';
  children: React.ReactNode;
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export function Button(props: Props) {
  const children = Children.map(
    props.children,
    child => typeof child !== 'string' ? child : <span>{child}</span>
  );
  return (
    <button
      type='button'
      className={`button ${props.className ? props.className + ' ' : ''}style--${props.style} color--${props.color}`}
      disabled={props.disabled}
      onClick={props.onClick}>
      {children}
    </button>
  );
}
